var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeed2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0215 0.353577H26.0215V2.35358H10.0215V0.353577Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0215 21.3536H0.0214844V19.3536H14.0215V21.3536Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02148 0.353577H8.02148V2.35358H6.02148V0.353577Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02148 0.353577H4.02148V2.35358H2.02148V0.353577Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0117 5.35358H27.6017C28.3706 5.35358 29.186 5.76982 29.8401 6.17957C30.5446 6.62093 31.2745 7.19513 31.9216 7.74858C32.573 8.30557 33.1619 8.85997 33.5868 9.27365C33.7998 9.48099 33.9727 9.65415 34.093 9.77613C34.1532 9.83714 34.2003 9.88543 34.2327 9.91886L34.2702 9.95763L34.2804 9.96818L34.2841 9.97207C34.2842 9.97218 34.2846 9.97258 33.5617 10.6636L34.2841 9.97207L34.3976 10.0908L38.4919 18.8189L46.4183 20.0759L46.1051 22.0512L37.1315 20.6282L32.7276 11.24C32.71 11.2221 32.6905 11.2023 32.6692 11.1806C32.557 11.0669 32.3937 10.9034 32.1916 10.7066C31.7865 10.3122 31.2305 9.78908 30.6218 9.26858C30.009 8.74453 29.3638 8.24122 28.7783 7.87446C28.1424 7.47608 27.7528 7.35358 27.6017 7.35358H16.0117V5.35358ZM25.1238 11.1298L19.8109 10.5374L20.0325 8.54973L26.1997 9.23736L29.4342 13.5107L28.8429 14.1263L28.2824 14.7092C27.9348 15.0704 27.4523 15.5714 26.9124 16.1306C25.8337 17.2481 24.5232 18.6012 23.6046 19.5349C23.0101 20.1391 22.7265 21.2691 22.9834 22.7558C23.2335 24.2038 23.9734 25.7912 25.114 27.0723L28.8589 30.9334L18.9839 37.1402L17.9196 35.4469L25.7045 30.5538L23.6498 28.4353L23.6363 28.4202C22.2444 26.8638 21.329 24.9279 21.0126 23.0963C20.7019 21.298 20.9433 19.3881 22.1789 18.1322C23.0902 17.206 24.3948 15.859 25.4735 14.7416C25.9958 14.2005 26.4645 13.7139 26.8089 13.3561L25.1238 11.1298ZM33.1975 19.7445L32.5328 18.7326L27.4762 23.6483L32.4016 30.9812C32.7976 31.57 32.5256 32.4398 31.794 32.7023L31.7746 32.7093L20.0354 37.4771L20.788 39.3301L32.4906 34.5771C34.3643 33.89 35.2212 31.5902 34.0616 29.8656L30.0672 23.9188L32.2023 21.8432C32.3478 22.0539 32.5099 22.2863 32.6816 22.5279C33.3044 23.4043 34.1195 24.4984 34.7186 25.0744L35.0089 25.3536H43.0017V23.3536H35.8393C35.4077 22.8691 34.8371 22.1084 34.3118 21.3693C34.0012 20.9322 33.722 20.525 33.5202 20.2269C33.4195 20.078 33.3383 19.9567 33.2826 19.8729L33.2188 19.7768L33.2026 19.7522L33.1986 19.7462L33.1975 19.7445Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1265 29.8583L8.00647 37.1283L7.03711 35.3789L20.1571 28.1089L21.1265 29.8583Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66406 33.677L18.6441 23.087L19.7986 24.7202L4.81858 35.3102L3.66406 33.677Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5215 8.35358C40.1408 8.35358 39.0215 9.47286 39.0215 10.8536C39.0215 12.2343 40.1408 13.3536 41.5215 13.3536C42.9022 13.3536 44.0215 12.2343 44.0215 10.8536C44.0215 9.47286 42.9022 8.35358 41.5215 8.35358ZM37.0215 10.8536C37.0215 8.3683 39.0362 6.35358 41.5215 6.35358C44.0068 6.35358 46.0215 8.3683 46.0215 10.8536C46.0215 13.3389 44.0068 15.3536 41.5215 15.3536C39.0362 15.3536 37.0215 13.3389 37.0215 10.8536Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed2);
export default __webpack_public_path__ + "static/media/speed_2.72891ffffae5a60429eb585b73c0e764.svg";
export { ForwardRef as ReactComponent };